import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, formatData, getUserNameToName } from '../../../../utils/util';
import { Button, Label, Input, Breadcrumbs } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import InputUI from '../../../../components/UI/InputUI';

const ContainerInsert = (props) => {
    const update = props.location?.state?.update;
    const [container, setContainer] = useState(props.location?.state?.update && props.container ? props.container : {});
    const [isSizeRequired, setIsSizeRequired] = useState(false);
    const [showFewerFields, setShowFewerFields] = useState(false);
    useEffect(() => {
        if (props.location?.state?.update && props.container) {
            setContainer({ ...props.container });
        }

        if (!props.containerTypes) props.getContainerTypes();
        if (!props.containerSizes) props.getContainerSizes();
        if ((props.maritimeCompanyList?.length ?? 0) === 0) props.getMaritimeCompanies();
        if ((props.harborList?.length ?? 0) === 0) props.getHarbors();
        if ((props.unloadLocations?.length ?? 0) === 0) props.getUnloadLocations();
        if ((props.containerStatus?.length ?? 0) === 0) props.getStatusContainer();

        // eslint-disable-next-line
    }, [props.location?.state?.update, props.container]);

    useEffect(() => {
        let isRequired = false;

        if (container?.type && props.containerTypes) {
            const requiredTypes = props.containerTypes.filter((x) =>
                x.containerTypeName === "Marítimo" ||
                x.containerTypeName === "Maritimo" ||
                x.containerTypeName === "Alugado" ||
                x.containerTypeName === "Local");

            isRequired = requiredTypes.some((x) => Number(x.id) === Number(container.type));
        }
        setIsSizeRequired(isRequired);
        let isShowFewerFields = false;
        if (container?.type && props.containerTypes) {
            const showFewerFields = props.containerTypes.filter((x) =>
                x.containerTypeName === "Alugado" ||
                x.containerTypeName === "Virtual" ||
                x.containerTypeName === "INTERNAL" ||
                x.containerTypeName === "Próprio");

            isShowFewerFields = showFewerFields.some((x) => Number(x.id) === Number(container.type));
        }
        setShowFewerFields(isShowFewerFields);


    }, [container, props.containerTypes]);

    const onChange = (event) => {
        onValueChange(event, container, setContainer);
    };

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {

        if (validateInputsRequired()) {
            container.supplierCode = "0";
            container.supplierName = "Fornecedor Interno";
            container.containerTypeName = props.containerTypes.find(c => Number(c.id) === Number(container?.type)).containerTypeName;
            if (update) {
                props.containerUpdate(container, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            } else {
                props.containerInsert(container, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            }
        }

    };

    const titlePlant = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.container', 'container') };

    const subtitlesPlant = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-domain", label: translate('menu.containerName', 'container') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'container') : translate('menu.insert', 'container') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="plantInsert" title={titlePlant} subtitles={subtitlesPlant()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="no-padding col s12">
                                        <SelectNew
                                            required
                                            id="type"
                                            name="type"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label={translate('fields.type', 'container')}
                                            data={props.containerTypes?.map((x) => ({ id: x.id, text: x.containerTypeName }))}
                                            change={onChange}
                                            value={container?.type || ""}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input required label={translate('fields.name', 'container')} id="name" name="name" type="text" maxlength={11} onChange={onChange} value={container?.name} />
                                    </div>
                                    <div className="no-padding col s12">
                                        <SelectNew
                                            required={isSizeRequired}
                                            id="size"
                                            name="size"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label={translate('fields.size', 'container')}
                                            data={props.containerSizes?.map((x) => ({ id: x.id, text: x.containerSizeName }))}
                                            change={onChange}
                                            value={container?.size || ""}
                                        />
                                    </div>
                                    {!showFewerFields &&
                                        <div>
                                            <div className="input-field no-padding col s12">
                                                <InputUI label={translate('fields.mvmNumber', 'container')} id="mvmNumber" name="mvmNumber" type="text" onChange={onChange} numericonly="true" maxlength={11} value={container?.mvmNumber} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.boardingCode', 'container')} id="boardingCode" name="boardingCode" type="text" onChange={onChange} maxlength={20} value={container?.boardingCode} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.processNumber', 'container')} id="processNumber" name="processNumber" type="text" onChange={onChange} numericonly="true" maxlength={6} value={container?.processNumber} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.containerShipName', 'container')} id="containerShipName" name="containerShipName" type="text" onChange={onChange} maxlength={20} value={container?.containerShipName} />
                                            </div>
                                            <div className="no-padding col s12">
                                                <SelectNew
                                                    id="maritimeCompanyId"
                                                    name="maritimeCompanyId"
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    label={translate('fields.maritimeCompany', 'container')}
                                                    data={props.maritimeCompanyList?.map((x) => ({ id: x.id, text: x.name }))}
                                                    change={onChange}
                                                    value={container?.maritimeCompanyId}
                                                />
                                            </div>
                                            <div className="no-padding col s12">
                                                <SelectNew
                                                    id="harborId"
                                                    name="harborId"
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    label={translate('fields.harbor', 'container')}
                                                    data={props.harborList?.map((x) => ({ id: x.id, text: `${x.code} - ${x.description}` }))}
                                                    change={onChange}
                                                    value={container?.harborId || ""}
                                                />
                                            </div>
                                            <div className="no-padding col s12">
                                                <SelectNew
                                                    id="status"
                                                    name="status"
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    label={translate('fields.status', 'container')}
                                                    data={props.containerStatus?.map((x) => ({ id: x.id, text: x.description }))}
                                                    change={onChange}
                                                    value={container?.status || ""}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.expirationDate', 'container')} id="expirationDate" name="expirationDate" type="date" onChange={onChange} value={container?.expirationDate} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.openingDate', 'container')} id="openingDate" name="openingDate" type="date" onChange={onChange} value={container?.openingDate} />
                                            </div>
                                            <div className="no-padding col s12">
                                                <SelectNew
                                                    id="unloadLocationId"
                                                    name="unloadLocationId"
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    label={translate('fields.unloadLocation', 'container')}
                                                    data={props.unloadLocations?.map((x) => ({ id: x.id, text: `${x.code} - ${x.description}` }))}
                                                    change={onChange}
                                                    value={container?.unloadLocationId || ""}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.nonProductiveTc', 'container')} id="nonProductiveTc" name="nonProductiveTc" type="checkbox" onChange={onChange} checked={container?.nonProductiveTc || false} />
                                            </div>
                                            <div className="input-field no-padding col s12">
                                                <Input label={translate('fields.observation', 'container')} id="observation" name="observation" type="text" maxlength={50} onChange={onChange} value={container?.observation} />
                                            </div>
                                        </div>
                                    }
                                </div>
                                {
                                    update &&
                                    <div className="row" style={{ marginBottom: '5px' }}>
                                        <Label label={translate('fields.updateBy', 'container')} id="updateBy" value={getUserNameToName(props?.usersFromElog, container?.updatedBy)} />
                                        <Label label={translate('fields.updateOn', "container")} id="updateOn" value={formatData(container?.updatedOn)} />
                                    </div>
                                }
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        container: state.containerReducer.container,
        usersFromElog: state.usersElogReducer.usersElog,
        containerTypes: state.containerReducer.containerTypes,
        containerSizes: state.containerReducer.containerSizes,
        maritimeCompanyList: state.containerReducer.maritimeCompanyList,
        harborList: state.containerReducer.harborList,
        unloadLocations: state.containerReducer.unloadLocationList,
        containerStatus: state.containerReducer.containerStatus
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        containerInsert: (container, callback) => {
            dispatch(ContainerService.insert(container, callback));
        },
        containerUpdate: (container, callback) => {
            dispatch(ContainerService.update(container, callback));
        },
        getContainerTypes: () => {
            dispatch(ContainerService.getContainerTypes(null));
        },
        getContainerSizes: () => {
            dispatch(ContainerService.getContainerSizes(null));
        },
        getMaritimeCompanies: () => {
            dispatch(ContainerService.getMaritimeCompany(null, () => { }));
        },
        getHarbors: () => {
            dispatch(ContainerService.getAllHarbor(null, () => { }));
        },
        getUnloadLocations: () => {
            dispatch(ContainerService.getUnloadLocation(null));
        },
        getStatusContainer: () => {
            dispatch(ContainerService.getStatusContainer());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContainerInsert)));
